import type {User} from 'nutshell-core/users/users-types';

import type {AccountPageFragment as Account} from 'nutshell-graphql-types';

import {CoreEntitySidebar} from '../../../core-entity/layout/core-entity-sidebar';
import {getWidgetComponents} from '../../../core-entity/util/widget-components';

type Props = {
    account: Account;
    user: User;
    hasScrolledPastCheckpoint: boolean;
    hasFullHeightSidebar?: boolean;
};

export function AccountSidebar(props: Props) {
    const isParentAccount = (props.account.childAccounts?.totalCount ?? 0) > 0;

    // Filter out CHILD_LEADS widget if it's not a parent account
    const sidebarWidgets = (props.account.sidebarWidgets ?? []).filter(
        (w) => w.type !== 'CHILD_LEADS' || isParentAccount
    );

    const widgets = getWidgetComponents({
        mode: 'account',
        widgets: sidebarWidgets,
        entityId: props.account.id,
        user: props.user,
    });

    return (
        <CoreEntitySidebar
            hasScrolledPastCheckpoint={props.hasScrolledPastCheckpoint}
            hasFullHeightSidebar={props.hasFullHeightSidebar}
        >
            {widgets}
        </CoreEntitySidebar>
    );
}
